// LoginLayout.jsx - version moderne avec image de fond et carte flottante
import React from 'react';
import { Box, Paper, Container } from '@mui/material';
import backgroundImage from '../../images/form-login.jpg'; 

const LoginLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        px: 2,
      }}
    >
      <Container maxWidth="xs" sx={{ pb: 4 }}>
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 4,
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          {children}
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginLayout;
